import React from 'react'

export default function ChangeApproverModal() {
  return (
    <div>
      <div
        className="modal fade"
        id="ChangeApproverModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="ChangeApproverLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-head">
              <h5 className="modal-title" id="ChangeApproverLabel">
                Edit Action
                <button
                  type="button"
                  className="close text-white"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </h5>
            </div>
            <div className="modal-middle pm-30">
              <div className="form-group custom labelup">
                <label>Action Name</label>
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-border-basic dropdown-toggle btn-block"
                    data-toggle="dropdown"
                  >
                    Change Approver
                  </button>
                  <div className="dropdown-menu">
                    <button type="button" className="dropdown-item">Change Approver</button>
                    <button type="button" className="dropdown-item">Generate Exception</button>
                    <button className="dropdown-item disabled">Reject (cash advance workflows only)</button>
                    <button className="dropdown-item">Send Back to Employee</button>
                    <button className="dropdown-item">Send Email</button>
                    <button className="dropdown-item ">Skip Step</button>
                  </div>
                </div>
              </div>
              <div className="form-group custom labelup">
                <input type="text" className="form-control" placeholder="Search User" />
                <label>Approver Name</label>
              </div>
              <div className=" modal-last btn-group-margin">
                <button
                  type="button"
                  className="btn btn-border-success"
                >
                  Save
              </button>
                <button
                  type="button"
                  className="btn btn-border-basic"
                  data-dismiss="modal"
                >
                  Cancel
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  )
}
